import {
  IOverlayParameter,
  ICircleGeometry,
  IPointSymbol,
  IPolylineSymbol,
  IResult,
  IPopUpTemplate,
  IOverlayClusterParameter,
  IOverlayDelete,
  IFindParameter,
  IPicChangeParameter
} from "@/types/map";
import { loadModules } from "esri-loader";
import TooltipPGIS from "@/plugin/gis-viewer/widgets/Overlays/pgis/TooltipPGIS";
import { Vue } from "vue-property-decorator";
import turfEnvelop from "@turf/envelope";
import * as turf from "@turf/helpers";
// import ToolTipBaiDu from "@/plugin/gis-viewer/widgets/Overlays/bd/ToolTipBaiDu";
declare let ol: any;

export default class OverlayPGIS {
  private static instance: Map<string, any>;

  private view!: any;
  private fmap!: any;
  private overlays = new Array();
  //控制showPopup,showTooltip单个弹窗
  private popup: any;
  private primitivePopup: any;
  private tooltip: any;
  private tooltips: TooltipPGIS[] = [];
  //features 与 feature.style集合，用于设置隐藏/显示覆盖物
  private featuresAndStyle: Map<any, any> = new Map<any, any>();
  public layerGroups: Map<string, any> = new Map<string, any>(); //<type,layer>
  private overlayLayers: any[] = []; //一次添加覆盖物的图层组
  public static hlFeatures: boolean;
  private featureSelected: any;
  private preSelected: any[] = [];
  private showFeaturesPopup: boolean = true;
  private glImageData: Map<string, any> = new Map<string, any>();

  private constructor(view: any, fmap: any) {
    this.view = view;
    this.fmap = fmap;

    if (!this.featureSelected) {
      this.handleFeatureSelectEvents();
    }
  }

  public static getInstance(view: any, fmap: any) {
    let id = view.getTarget();
    if (!OverlayPGIS.instance) {
      OverlayPGIS.instance = new Map();
    }
    let instance = OverlayPGIS.instance.get(id);
    if (!instance) {
      instance = new OverlayPGIS(view, fmap);
      OverlayPGIS.instance.set(id, instance);
    }
    return instance;
  }

  private async getOverlayLayer(type: string) {
    let layer = this.layerGroups.get(type);
    if (!layer) {
      layer = await this.createOverlayLayer(type);
    }
    return layer;
  }

  //一次性添加的覆盖物创建一个vectorLayer
  private async createOverlayLayer(type: string): Promise<any> {
    //存储原始矢量点、线、面
    const vectorLayer = new ol.layer.Vector({
      source: new ol.source.Vector({}),
      style: new ol.style.Style({
        image: new ol.style.Circle({
          radius: 1,
          fill: new ol.style.Fill({
            color: "rgba(0,0,0,0)"
          })
        })
      })
    });
    vectorLayer.title = "vectorLayer_" + type;
    this.overlayLayers.push(vectorLayer); //获取当前加点后的图层
    this.view.addLayer(vectorLayer);
    this.layerGroups.set(type, vectorLayer);
    return vectorLayer;
  }

  private async loadImageAsync(url: string, size: number) {
    let _this = this;
    let url_size = url + "_" + size;
    return new Promise(function (resolve, reject) {
      let scale = _this.glImageData.get(url_size);
      if (scale) {
        resolve(scale);
      } else {
        const image = new Image();
        image.src = url;
        image.onload = function () {
          let width = image.width;
          let scale = size / width;
          _this.glImageData.set(url_size, scale);
          resolve(scale);
        };
        image.onerror = function () {
          reject(1);
        };
      }
    });
  }

  public async addOverlays(params: IOverlayParameter): Promise<IResult> {
    const defaultSymbol = params.defaultSymbol;
    const overlayType = params.type || params.overlays[0].type || "overlays";
    const defaultButtons = params.defaultButtons;
    const defaultInfoTemplate = params.defaultInfoTemplate;
    const centerResult = params.centerResult !== false;
    const transform = params.transform;
    const custom = params.custom;
    const defaultVisible = params.defaultVisible !== false;
    //自定义vue弹窗样式
    /************auto/move/show-popup/tooltip*****************/
    const tooltipComponent = params.tooltipComponent;
    const popupComponent = params.popupComponent;
    const level = params.level || this.view.getView().getZoom();

    let addCount = 0;
    if (!params.overlays.length) {
      return {
        status: 0,
        message: "无覆盖物参数输入！"
      };
    }

    // console.log("overlayLayer type:",overlayType);
    const overlayLayer = await this.getOverlayLayer(overlayType);

    // console.log("get overlayLayer:",overlayLayer);

    const features: any[] = [];
    const turfPoints: any[] = [];
    for (let overlayObj of params.overlays) {

      const geometry: any = overlayObj.geometry;

      //symbol的类型"point" "polyline" "polygon"

      const overlaySymbol = overlayObj.symbol || defaultSymbol || { type: undefined };

      if (!overlaySymbol.type) {
        overlaySymbol.type = (defaultSymbol && defaultSymbol.type) ? defaultSymbol.type : geometry.type;
      }

      //确保overlaySymbol的type符合openlayers规范
      overlaySymbol.type = this._formatSymbolType(overlaySymbol.type) || overlaySymbol.type;

      let style = await this.getStyle(overlaySymbol);

      if (!style) {
        continue;
      }

      let overlayGeo: any;
      if (transform === "BD9ToWGS84") {
        if (overlaySymbol.type === "point") {
          let coordinate = this.fmap.BD9ToWGS84(geometry.x, geometry.y);
          overlayGeo = { x: coordinate[0], y: coordinate[1] };
        } else if (overlaySymbol.type === "polyline") {
          const coordinates = geometry.paths;
          coordinates.forEach((coordinate: number[], index: number) => {
            coordinates[index] = this.fmap.BD9ToWGS84(
              coordinate[0],
              coordinate[1]
            );
          });
          console.log("BD9ToWGS84 line coordinates=", JSON.stringify(coordinates));
          overlayGeo = { paths: coordinates };
        } else if (overlaySymbol.type === "polygon") {
          const coordinates = geometry.rings;
          coordinates.forEach((coordinate: number[], index: number) => {
            coordinates[index] = this.fmap.BD9ToWGS84(
              coordinate[0],
              coordinate[1]
            );
          });
          overlayGeo = { rings: coordinates };
        }
      } else {
        overlayGeo = geometry;
      }

      let overlayGeoType = overlaySymbol.type || overlayGeo.type;//由geometry中的type优先决定geotype

      if (overlayGeoType === "point") {
        turfPoints.push(turf.point([geometry.x, geometry.y]));
      } else if (overlayGeoType === "polyline") {
        let paths = geometry.paths;
        //@todo 暂时只处理一条线的情况
        //paths可能有两种数据格式：1、表示线串：paths[][],每行是一条线；2、表示一条线，paths[points]
        let path = paths[0];
        path.forEach((point: any) => {
          turfPoints.push(turf.point([point[0], point[1]]));
        });
      } else if (overlayGeoType === "polygon") {
        let rings = geometry.rings;
        //@todo 暂时只处理一个环的情况
        let ring = rings[0];
        ring.forEach((point: any) => {
          turfPoints.push(turf.point([point[0], point[1]]));
        });
      } else {
        return {
          status: 0,
          message: "不支持的覆盖物类型:" + overlayGeoType,
        };
      }

      const feature = this.getFeature(overlayGeoType, overlayGeo);

      feature.attributes = overlayObj.fields;
      feature.buttons = overlayObj.buttons || defaultButtons;
      feature.attributes.id = feature.id = overlayObj.id;
      feature.attributes.type = feature.type = overlayObj.type || overlayType;
      feature.attributes.popup = popupComponent;
      feature.attributes.tooltip = tooltipComponent;
      feature.defaultInfoTemplate = defaultInfoTemplate;

      // const style = await overlayObj.style || this.getStyle(overlaySymbol);
      // let style = await this.getStyle(overlaySymbol);
      // style = this.getStyle(overlaySymbol);

      // console.log("overlaySymbol", overlaySymbol);

      if (custom) {
        style.setText(
          new ol.style.Text({
            textAlign: "center",
            textBaseline: "middle",
            font: (custom.fontSize || "14px") + " 微软雅黑",
            text: this.getPopUpHtml(feature, custom.content),
            fill: new ol.style.Fill({ color: custom.fontColor || "red" })
          })
        );
      }
      feature.setStyle(style);

      features.push(feature);
      overlayLayer.getSource().addFeature(feature);

      addCount++;
    }

    if (centerResult) {
      if (turfPoints.length) {
        const features = turf.featureCollection(turfPoints);
        const envelope = turfEnvelop(features);
        const geom = new ol.geom.Polygon(envelope.geometry.coordinates);
        this.view.getView().fit(geom, {
          duration: 1000,
          maxZoom: level
        });
      } else if (features.length === 1) {
        this.view.getView().fit(features[0].getGeometry(), {
          duration: 1000,
          maxZoom: level
        });
      }
    }

    let title: any;
    let content: string = "";

    const autoTooltip = params.autoTooltip;
    if (autoTooltip && tooltipComponent) {
      await this.autoTooltip(features);
    }

    return {
      status: 0,
      message: "ok",
      result: `成功添加${params.overlays.length}中的${addCount}个覆盖物`
    };
  }

  private getPopUpHtml(graphic: any, content: string): any {
    let tipContent = content;
    for (let fieldName in graphic.attributes) {
      if (graphic.attributes.hasOwnProperty(fieldName)) {
        tipContent = tipContent.replace(
          new RegExp("{" + fieldName + "}", "g"),
          graphic.attributes[fieldName]
        );
      }
    }
    return tipContent;
  }

  public async findFeature(params: IFindParameter): Promise<IResult> {
    const type = params.layerName;
    if (!type) {
      return {
        status: 0,
        message: "layerName attributes is required!"
      };
    }
    const ids = params.ids;
    if (!(ids instanceof Array) || !ids.length) {
      return {
        status: 0,
        message: "check out ids attributes!"
      };
    }

    const centerResult = params.centerResult !== false;
    const animation = params.animation;
    const returnResult: any = {};
    const layerOfType = this.layerGroups.get(type);
    const level = params.level || this.view.getView().getZoom();
    if (!(layerOfType instanceof ol.layer.Vector)) {
      return {
        status: 0,
        message: "check out types attributes!"
      };
    }
    const features = layerOfType.getSource().getFeatures();
    for (let feature of features) {
      if (ids.indexOf(feature.id) > -1) {
        returnResult.id = feature.id;
        returnResult.type = feature.type;
        returnResult.attributes = feature.attributes;
        returnResult.geometry = {
          coordinates: feature.getGeometry().getCoordinates(),
          type: feature.getGeometry().getType()
        };

        if (centerResult) {
          this.view.getView().fit(feature.getGeometry(), {
            duration: 1000,
            maxZoom: level
          });
        }

        if (animation) {
          if (centerResult) {
            await sleep(1000);
          }
          const curStyle = feature.getStyle();

          feature.setStyle(null);
          for (let i = 0; i < 5; i++) {
            await sleep(250);
            feature.setStyle(curStyle);
            await sleep(250);
            feature.setStyle(null);
          }
          feature.setStyle(curStyle);
        }
      }
    }

    function sleep(params: number) {
      let promise = new Promise((resolve) => {
        setTimeout(() => {
          resolve(null);
        }, params);
      });

      return promise;
    }
    return {
      status: 0,
      message: "成功调用该方法！",
      result: returnResult ? JSON.stringify(returnResult) : "未找到任何覆盖物！"
    };
  }

  public async deleteOverlays(params: IOverlayDelete): Promise<IResult> {
    const types = params.types || [];
    const ids = params.ids || [];
    if (!types.length && !ids.length) {
      return {
        status: 0,
        message: "请输入id或type值"
      };
    }

    let delCount = 0;
    let promises = [];
    if (types.length) {
      for (let type of types) {
        const layerOfType = this.layerGroups.get(type);
        if (!(layerOfType instanceof ol.layer.Vector)) {
          continue;
        }
        const source = layerOfType.getSource();
        const features = source.getFeatures();

        if (!ids.length) {
          source.clear();
          promises.push(this.closeTooltip({ types: [type] }));
          continue;
        }
        for (let feature of features) {
          if (ids.indexOf(feature.id) > -1) {
            source.removeFeature(feature);
            delCount++;
            promises.push(
              this.closeTooltip({ types: [type], ids: [feature.id] })
            );
          }
        }
      }
    }
    if (ids.length && !types.length) {
      for (let layer of this.layerGroups.values()) {
        if (!(layer instanceof ol.layer.Vector)) {
          continue;
        }
        const source = layer.getSource();
        const features = source.getFeatures();

        for (let feature of features) {
          if (ids.indexOf(feature.id) > -1) {
            source.removeFeature(feature);
            promises.push(this.closeTooltip({ ids: [feature.id] }));
          }
        }
      }
    }

    await Promise.all(promises);
    return {
      status: 0,
      message: "成功调用deleteOverlays方法"
    };
  }

  public async showOverlays(params: IOverlayDelete): Promise<IResult> {
    const types = params.types || [];
    const ids = params.ids || [];
    if (!types.length && !ids.length) {
      return {
        status: 0,
        message: "请输入id或type值"
      };
    }

    let showCount = 0;
    let tooltipIds = [];
    let tooltipTypes = [];
    for (let feature of this.featuresAndStyle.keys()) {
      if (
        //只判断type
        (types.length > 0 &&
          ids.length === 0 &&
          types.indexOf(feature.type) >= 0) ||
        //只判断id
        (types.length === 0 &&
          ids.length > 0 &&
          ids.indexOf(feature.id) >= 0) ||
        //type和id都要判断
        (types.length > 0 &&
          ids.length > 0 &&
          types.indexOf(feature.type) >= 0 &&
          ids.indexOf(feature.id) >= 0)
      ) {
        const style = this.featuresAndStyle.get(feature);
        feature.setStyle(style);
        if (feature.autoTooltip) {
          // showTooltipPromises.push(this.showTooltip({ids:[]}))
          tooltipIds.push(feature.id);
          tooltipTypes.push(feature.type);
        }

        this.featuresAndStyle.delete(feature);
        showCount++;
      }
    }

    await this.showOverlayTooltip({ ids: tooltipIds, types: tooltipTypes });
    return {
      status: 0,
      message: "成功调用该方法！",
      result: showCount
        ? `成功显示${showCount}个覆盖物,一共隐藏${this.featuresAndStyle.size}个覆盖物`
        : "未显示任何覆盖物"
    };
  }

  public async hideOverlays(params: IOverlayDelete): Promise<IResult> {
    const types = params.types || [];
    const ids = params.ids || [];

    if (!types.length && !ids.length) {
      return {
        status: 0,
        message: "请输入id或type值"
      };
    }

    let hideNum = 0;
    let tooltipIds: any = [];
    let tooltipTypes: any = [];
    if (types.length) {
      for (let type of types) {
        const layerOfType = this.layerGroups.get(type);
        if (layerOfType instanceof ol.layer.Vector) {
          const featuresOfType = layerOfType.getSource().getFeatures();

          if (ids.length) {
            featuresOfType.forEach((featureOfType: any) => {
              if (ids.indexOf(featureOfType.id) > -1) {
                const style = featureOfType.getStyle();
                if (style === null) {
                  return;
                }

                this.featuresAndStyle.set(featureOfType, style);
                featureOfType.setStyle(null);
                if (featureOfType.autoTooltip) {
                  tooltipIds.push(featureOfType.id);
                }

                hideNum++;
              }
            });
          } else {
            for (let featureOfType of featuresOfType) {
              const style = featureOfType.getStyle();
              if (style === null) {
                //说明已经处于隐藏状态
                continue;
              }

              this.featuresAndStyle.set(featureOfType, style);
              featureOfType.setStyle(null);
              hideNum++;
            }
            tooltipTypes.push(type);
          }
        }
      }
    }

    if (ids.length && !types.length) {
      this.overlayLayers.forEach((overlayLayer: any) => {
        if (!(overlayLayer instanceof ol.layer.Vector)) {
          return;
        }
        const features = overlayLayer.getSource().getFeatures();
        features.forEach((feature: any) => {
          if (ids.indexOf(feature.id) > -1) {
            const style = feature.getStyle();
            if (style === null) {
              return;
            }
            this.featuresAndStyle.set(feature, style);
            feature.setStyle(null);

            tooltipIds.push(feature.id);
            hideNum++;
          }
        });
      });
    }
    await this.hideTooltips({ ids: tooltipIds, types: tooltipTypes });

    return {
      status: 0,
      message: "成功调用该方法！",
      result: hideNum
        ? `成功隐藏${hideNum}个覆盖物,一共隐藏${this.featuresAndStyle.size}个覆盖物`
        : "未隐藏覆盖物"
    };
  }

  public async changePicById(params: IPicChangeParameter): Promise<IResult> {
    const type = params.type;
    const id = params.id;
    const curPicUrl = params.pictureUrl;
    const callback = params.callback || false;
    const isSelected = params.isSelected || false;

    let result: any = null;
    if (type && typeof type === "string") {
      const layerOfType = this.layerGroups.get(type);
      if (layerOfType instanceof ol.layer.Vector) {
        const features = layerOfType.getSource().getFeatures();

        for (let feature of features) {
          if (feature.id === id && feature.type === type) {
            let featureStyle = feature.getStyle();
            if (!featureStyle) {
              featureStyle = this.featuresAndStyle.get(feature);
            }
            // const featureImageSize= featureStyle.getImage().getSize();
            const img = new ol.style.Icon({
              src: curPicUrl
              // size:featureImageSize
            });
            featureStyle.setImage(img);
            feature.setStyle(featureStyle);
            this.featuresAndStyle.set(feature, featureStyle);
            feature.isSelected = feature.attributes.isSelected = isSelected;

            if (callback) {
              let callbackResult: any = {};
              callbackResult.id = feature.id;
              callbackResult.type = feature.type;
              callbackResult.geometry = {
                coordinates: feature.getGeometry().getCoordinates(),
                type: feature.getGeometry().getType()
              };
              callbackResult.attributes = feature.attributes;
              result = callbackResult;
            }
          }
        }
      }
    } else {
      this.layerGroups.forEach((layer: any) => {
        if (!(layer instanceof ol.layer.Vector)) {
          return;
        }
        const source = layer.getSource();
        const features = source.getFeatures();

        for (let feature of features) {
          if (feature.id === id) {
            let featureStyle = feature.getStyle();
            if (!featureStyle) {
              featureStyle = this.featuresAndStyle.get(feature);
            }
            // const featureImageSize= featureStyle.getImage().getSize();
            const img = new ol.style.Icon({
              src: curPicUrl
              // size:featureImageSize
            });
            featureStyle.setImage(img);
            feature.setStyle(featureStyle);
            this.featuresAndStyle.set(feature, featureStyle);
            feature.isSelected = feature.attributes.isSelected = isSelected;

            if (callback) {
              let callbackResult: any = {};
              callbackResult.id = feature.id;
              callbackResult.type = feature.type;
              callbackResult.geometry = {
                coordinates: feature.getGeometry().getCoordinates(),
                type: feature.getGeometry().getType()
              };
              callbackResult.attributes = feature.attributes;
              result = callbackResult;
            }
          }
        }
      });
    }

    return {
      message: "成功调用该方法",
      status: 0,
      result: callback
        ? JSON.stringify(result)
        : "获取该点位信息请在方法中加入callback属性"
    };
  }
  /*****************************popups***********************************/
  //根据id和type添加弹窗,单一存在
  public async showPopup(params: IOverlayDelete): Promise<IResult> {
    if (this.popup) {
      await this.closePopup();
    }
    const types = params.types || [];
    const ids = params.ids || [];
    if (!types.length && !ids.length) {
      return {
        status: 0,
        message: "types or ids are required!"
      };
    }

    if (types.length) {
      for (let type of types) {
        const layerOfType = this.layerGroups.get(type);
        if (!(layerOfType instanceof ol.layer.Vector)) {
          continue;
        }
        const overlays = layerOfType.getSource().getFeatures();
        for (let overlay of overlays) {
          if (ids.length) {
            if (ids.indexOf(overlays.id) > -1) {
              const popup = await this.showOverlayPopup(overlay);
              if (this.popup) {
                this.popup.remove();
                this.popup = null;
              }
              if (popup) {
                this.popup = popup;
              }
            }
          }
        }
      }
    }

    if (ids.length && !types.length) {
      for (let layer of this.layerGroups.values()) {
        if (!(layer instanceof ol.layer.Vector)) {
          continue;
        }
        const overlays = layer.getSource().getFeatures();
        for (let overlay of overlays) {
          if (ids.indexOf(overlay.id) > -1) {
            const popup = await this.showOverlayPopup(overlay);
            if (this.popup) {
              this.popup.remove();
              this.popup = null;
            }
            if (popup) {
              this.popup = popup;
            }
          }
        }
      }
    }

    return {
      status: 0,
      message: "ok",
      result: "成功调用方法，但无法保证可以正确显示弹窗"
    };
  }
  //关闭当前显示弹窗
  public async closePopup(): Promise<IResult> {
    let close = false;
    if (this.popup) {
      this.popup.remove();
      this.popup = null;
      close = true;
    }

    return {
      status: 0,
      message: "ok",
      result: close ? "成功关闭VUE弹窗" : "未存在VUE弹窗"
    };
  }
  //添加某一覆盖物弹窗
  private async showOverlayPopup(
    overlay: any,
    clickPoint?: Array<number>
  ): Promise<any> {
    if (this.popup) {
      this.popup.remove();
      this.popup = null;
    }
    let picSize = overlay
      .getStyle()
      .getImage()
      .getSize();
    const picScale = overlay
      .getStyle()
      .getImage()
      .getScale();
    picSize = [picSize[0] * picScale, picSize[1] * picScale];
    const fields = overlay.attributes;
    if (!fields) {
      return;
    }
    const popup = fields.popup;
    let content: any = fields.popupWindow;
    if (fields.popupWindow === false || !popup) {
      return;
    }
    const geometryType = overlay.getGeometry().getType();
    const center =
      geometryType == "Point"
        ? overlay.getGeometry().getCoordinates()
        : clickPoint;
    if (content && content.hasOwnProperty("valuePromise")) {
      content.valuePromise = await content.valuePromise;
    }
    if (typeof content == "boolean" || content === undefined) {
      content = {};
    }
    if (fields) {
      for (let field in fields) {
        content[field] = fields[field];
      }
    }
    const tooltipObj = {
      view: this.view,
      component: popup,
      props: content,
      position: center,
      picSize: picSize
    };
    this.popup = new TooltipPGIS(tooltipObj);
    popup.id = overlay.id;
    popup.type = overlay.type;

    return popup;
  }

  private async showPrimitivePopup(
    overlay: any,
    content: any,
    clickPoint: Array<number>
  ): Promise<any> {
    if (this.primitivePopup) {
      this.view.removeOverlay(this.primitivePopup); // 删除元素
    }
    const geometryType = overlay.getGeometry().getType();
    let tipContent = content;
    for (let fieldName in overlay.attributes) {
      if (overlay.attributes.hasOwnProperty(fieldName)) {
        tipContent = tipContent.replace(
          new RegExp("{" + fieldName + "}", "g"),
          overlay.attributes[fieldName]
        );
      }
    }
    let divContent = document.createElement("div");
    divContent.id = "gis-overlay";
    divContent.innerHTML = tipContent;
    const olPopup = new ol.Overlay({
      element: divContent,
      autoPan: true, // 是否自动平移，当点击时对话框超出屏幕边距，会自动平移地图使其可见
      className: "gis-overlay" // 覆盖物在覆盖层的类名
    });
    this.primitivePopup = olPopup;
    const center =
      geometryType == "Point"
        ? overlay.getGeometry().getCoordinates()
        : clickPoint;
    this.view.addOverlay(this.primitivePopup);
    this.primitivePopup.setPosition(center);
    console.log(
      this.primitivePopup.element.clientWidth,
      this.primitivePopup.element.clientHeight
    );
    this.primitivePopup.setOffset([
      -this.primitivePopup.element.clientWidth / 2,
      -(this.primitivePopup.element.clientHeight + 20)
    ]);
  }

  private async closePrimitivePopup(): Promise<any> {
    this.view.removeOverlay(this.primitivePopup); // 删除元素
  }
  /*****************************popups ending****************************/

  /***************************tooltips***********************************/
  //根据id和type 添加某些点位弹窗,添加到this.tooltips
  public async showTooltip(params: IOverlayDelete): Promise<IResult> {
    const types = params.types || [];
    const ids = params.ids || [];
    if (!types.length && !ids.length) {
      return {
        status: 0,
        message: "types or ids are required!"
      };
    }

    if (types.length) {
      for (let type of types) {
        const layerOfType = this.layerGroups.get(type);
        if (!(layerOfType instanceof ol.layer.Vector)) {
          continue;
        }
        const overlays = layerOfType.getSource().getFeatures();
        for (let overlay of overlays) {
          if (ids.length) {
            if (ids.indexOf(overlays.id) > -1) {
              const tooltip = await this.addOverlayTooltip(overlay);
              if (tooltip) {
                overlay.autoTooltip = true;
                this.tooltips.push(tooltip);
              }
            }
          }
        }
      }
    }

    if (ids.length && !types.length) {
      for (let layer of this.layerGroups.values()) {
        if (!(layer instanceof ol.layer.Vector)) {
          continue;
        }
        const overlays = layer.getSource().getFeatures();
        for (let overlay of overlays) {
          if (ids.indexOf(overlay.id) > -1) {
            const tooltip = await this.addOverlayTooltip(overlay);
            if (tooltip) {
              overlay.autoTooltip = true;
              this.tooltips.push(tooltip);
            }
          }
        }
      }
    }
    return {
      status: 0,
      message: "ok",
      result: "成功调用方法，但无法保证可以正确显示弹窗"
    };
  }
  //自动添加某些点位弹窗，添加到this.tooltips
  private async autoTooltip(params: any[]): Promise<any> {
    const overlays = params;
    for (let overlay of overlays) {
      let fields = overlay.attributes;
      if (!fields) {
        continue;
      }
      let content: any = fields.tooltipWindow;
      let tooltipComponent: any = fields.tooltip;
      if (!content || !tooltipComponent) {
        continue;
      }
      const center = overlay.getGeometry().getCoordinates();
      const picSize = overlay
        .getStyle()
        .getImage()
        .getSize();
      if (content.hasOwnProperty("valuePromise")) {
        await content.valuePromise;
      }

      const tooltipObj = {
        view: this.view,
        component: tooltipComponent,
        props: content,
        position: center,
        picSize: picSize
      };
      const tooltip = new TooltipPGIS(tooltipObj);
      tooltip.id = overlay.id;
      tooltip.type = overlay.type;

      overlay.autoTooltip = true;
      this.tooltips.push(tooltip);
    }
  }
  //根据id和type 显示某些点位弹窗
  public async showOverlayTooltip(params: IOverlayDelete): Promise<any> {
    const types = params.types || [];
    const ids = params.ids || [];
    if (!types.length && !ids.length) {
      return {
        status: 0,
        message: "请输入id或type值"
      };
    }

    let showNum = 0;
    for (let tooltip of this.tooltips) {
      if (
        //只判断type
        (types.length > 0 &&
          ids.length === 0 &&
          types.indexOf(tooltip.type) >= 0) ||
        //只判断id
        (types.length === 0 &&
          ids.length > 0 &&
          ids.indexOf(tooltip.id) >= 0) ||
        //type和id都要判断
        (types.length > 0 &&
          ids.length > 0 &&
          types.indexOf(tooltip.type) >= 0 &&
          ids.indexOf(tooltip.id) >= 0)
      ) {
        tooltip.show();
        showNum++;
      }
    }

    return {
      status: 0,
      message: "成功调用该方法！",
      result: showNum ? `成功显示${showNum}个弹窗！` : "未显示任何弹窗！"
    };
  }
  //根据id和type 隐藏某些点位弹窗
  private async hideTooltips(params: IOverlayDelete): Promise<IResult> {
    const types = params.types || [];
    const ids = params.ids || [];

    if (!types.length && !ids.length) {
      return {
        status: 0,
        message: "请输入type或id值！"
      };
    }

    let hideCount = 0;
    this.tooltips.forEach((tooltip: TooltipPGIS) => {
      if (
        //只判断type
        (types.length > 0 &&
          ids.length === 0 &&
          types.indexOf(tooltip.type) >= 0) ||
        //只判断id
        (types.length === 0 &&
          ids.length > 0 &&
          ids.indexOf(tooltip.id) >= 0) ||
        //type和id都要判断
        (types.length > 0 &&
          ids.length > 0 &&
          types.indexOf(tooltip.type) >= 0 &&
          ids.indexOf(tooltip.id) >= 0)
      ) {
        tooltip.hide();
        hideCount++;
      }
    });

    return {
      status: 0,
      message: "成功调用该方法！",
      result: hideCount ? `成功隐藏${hideCount}个弹窗` : `未隐藏任何弹窗！`
    };
  }
  //根据id和type关闭弹窗
  public async closeTooltip(params: IOverlayDelete): Promise<IResult> {
    const types = params.types || [];
    const ids = params.ids || [];

    if (!types.length && !ids.length) {
      return {
        status: 0,
        message: "请输入type或id值！"
      };
    }

    let closeCount = 0;
    this.tooltips.forEach((tooltip: TooltipPGIS) => {
      if (
        //只判断type
        (types.length > 0 &&
          ids.length === 0 &&
          types.indexOf(tooltip.type) >= 0) ||
        //只判断id
        (types.length === 0 &&
          ids.length > 0 &&
          ids.indexOf(tooltip.id) >= 0) ||
        //type和id都要判断
        (types.length > 0 &&
          ids.length > 0 &&
          types.indexOf(tooltip.type) >= 0 &&
          ids.indexOf(tooltip.id) >= 0)
      ) {
        tooltip.remove();
        closeCount++;
      }
    });

    return {
      status: 0,
      message: "成功调用该方法！",
      result: closeCount ? `成功关闭${closeCount}个弹窗` : `未关闭弹窗`
    };
  }
  //关闭所有存在的tooltips
  public async closeAllTooltips(): Promise<IResult> {
    await this.closePopup();
    if (this.tooltips.length) {
      this.tooltips.forEach((tooltip) => {
        tooltip.remove();
      });
    }

    this.tooltips = [];
    return {
      status: 0,
      message: "成功调用该方法"
    };
  }
  /********************tooltips   Ending***********************************/
  private async handleFeatureSelectEvents(): Promise<any> {
    // if(this.selectInteraction){
    //   return ;
    // }
    //
    // this.selectInteraction = new ol.interaction.Select({
    //   layers:this.overlayLayers,
    // });
    //
    // this.view.addInteraction(this.selectInteraction);
    //
    // this.view.on("moveend",() => {
    //   if(this.featureSelected){
    //     this.addHighlightFrame(this.featureSelected);
    //   }
    // })

    // this.selectInteraction.on("select",async (e:any) => {
    //   const features=e.selected;
    //   const feature=features[0];
    //   if(!feature){
    //     // if(this.preSelected[0] && this.preSelected[1]){
    //     //   this.preSelected[0].setStyle(this.preSelected[1]);
    //     //   this.preSelected = [];
    //     // }
    //     this.featureSelected = null;
    //
    //     const hlLayer = await this.getOverlayLayer("hlFeatures");
    //     hlLayer.getSource().clear();
    //     await this.closePopup();
    //
    //     return ;
    //   }
    //
    //   this.featureSelected = feature;
    //   const geometryType=feature.getGeometry().getType();
    //   if(geometryType === "Point"){
    //     if(this.showFeaturesPopup){
    //       this.showOverlayPopup(feature);
    //     }
    //     //
    //     this.changeFeatureStyle(feature);
    //     if(feature.type !== "hlFeatures" && OverlayPGIS.hlFeatures){
    //       this.addHighlightFrame(feature);
    //     }
    //
    //   }
    // });

    // const _this = this;
    // this.featureSelected = this.view.on("singleclick", async (evt: any) => {
    //   const pixel = evt.pixel;
    //   if (_this.view.hasFeatureAtPixel(pixel)) {
    //     const features = _this.view.getFeaturesAtPixel(pixel);
    //     const feature = features[0]; //只选择最外层的一个覆盖物
    //     if (!feature) {
    //       return;
    //     }
    //     const geometryType = feature.getGeometry().getType();
    //     if (geometryType === "Point") {
    //       if (_this.showFeaturesPopup) {
    //         _this.showOverlayPopup(feature);
    //       }
    //     }
    //   } else {
    //     await this.closePopup();
    //   }
    // });

    let _this = this;
    this.featureSelected = this.view.on("singleclick", async (evt: any) => {
      const pixel = evt.pixel;
      if (_this.view.hasFeatureAtPixel(pixel)) {
        let features = _this.view.getFeaturesAtPixel(pixel);
        let feature = features[0]; //只选择最外层的一个覆盖物
        if (feature.attributes?.popup) {
          // const features = this.view.getFeaturesAtPixel(pixel);
          // const feature = features[0]; //只选择最外层的一个覆盖物
          if (!feature) {
            return;
          }
          const geometryType = feature.getGeometry().getType();
          if (geometryType === "Point" && feature.attributes) {
            //添加自定义弹窗
            //todo
            _this.showOverlayPopup(feature, evt.coordinate);
          }
        } else {
          _this.closePopup();
        }

        if (feature.defaultInfoTemplate) {
          let content = feature.defaultInfoTemplate.content;

          // const features = this.view.getFeaturesAtPixel(pixel);
          // const feature = features[0]; //只选择最外层的一个覆盖物
          if (!feature) {
            return;
          }

          if (feature.attributes) {
            //添加自定义弹窗
            _this.showPrimitivePopup(feature, content, evt.coordinate);
          }
        } else {
          await _this.closePrimitivePopup();
        }
      } else {
        _this.closePopup();
        _this.closePrimitivePopup();
      }
    });
  }

  private async addOverlayTooltip(overlay: any): Promise<any> {
    const picSize = overlay
      .getStyle()
      .getImage()
      .getSize();
    let fields = overlay.attributes;
    if (!fields) {
      return false;
    }
    let content: any = fields.tooltipWindow;
    let tooltipComponent: any = fields.tooltip;
    if (!content || !tooltipComponent) {
      return false;
    }
    const center = overlay.getGeometry().getCoordinates();

    if (content.hasOwnProperty("valuePromise")) {
      await content.valuePromise;
    }

    const tooltip = new TooltipPGIS({
      view: this.view,
      component: tooltipComponent,
      props: content,
      position: center,
      picSize: picSize
    });
    tooltip.id = overlay.id;
    tooltip.type = overlay.type;

    return tooltip;
  }

  private async getStyle(params: any): Promise<any> {
    const symbol = params;
    let vectorStyle: any;
    switch (symbol.type) {
      case "point-2d":
      case "point":
        if (symbol.primitive) {
          const radius = symbol.size || 5;
          const color = symbol.color || "#c0ad00";
          vectorStyle = new ol.style.Style({
            image: new ol.style.Circle({
              radius: radius,
              fill: new ol.style.Fill({
                color: color
              })
            })
          });
        } else {
          const src = symbol.url;
          const size: any = symbol.size || [];
          const offset: any = [symbol.xoffset, symbol.yoffset] || [];
          if (!src || typeof src !== "string") {
            return {
              status: 0,
              message: "点url属性错误！"
            };
          }
          /*暂时解决图片不能改变大小的问题*/
          let scale: any = 1;
          if (size.length && typeof size[0] === "number") {
            scale = await this.loadImageAsync(src, size[0]);
          }

          const img = new ol.style.Icon({
            src: src,
            scale
          });
          vectorStyle = new ol.style.Style({});
          vectorStyle.setImage(img);

          if (offset.length && typeof offset[0] === "number") {
            img.offset = offset;
            vectorStyle.setImage(img);
          }
        }
        break;
      case "line":
      case "simple-line":
      case "polyline":
        const color = symbol.color;
        const width = symbol.width;
        const plStroke = new ol.style.Stroke({
          color: "rgb(0,253,50)",
          width: 5
        });
        vectorStyle = new ol.style.Style({
          stroke: new ol.style.Stroke({
            color: "rgb(0,253,50)",
            width: 5
          })
        });
        vectorStyle.setStroke(plStroke);
        if (color) {
          plStroke.setColor(color);
          vectorStyle.setStroke(plStroke);
        }
        if (width) {
          plStroke.setWidth(width);
          vectorStyle.setStroke(plStroke);
        }
        break;
      case "fill":
      case "simple-fill":
      case "polygon":
        const polygonColor = symbol.color;
        const outline = symbol.outline;
        vectorStyle = new ol.style.Style({});
        const olStroke = new ol.style.Stroke({
          color: "rgb(0,0,0)",
          width: 1
        });
        vectorStyle.setStroke(olStroke);
        const fill = new ol.style.Fill({
          color: "rgba(0,208,254,0.5)"
        });
        vectorStyle.setFill(fill);
        if (outline && outline.color) {
          olStroke.setColor(outline.color);
          vectorStyle.setStroke(olStroke);
        }
        if (outline && outline.width) {
          olStroke.setWidth(outline.width);
          vectorStyle.setStroke(olStroke);
        }
        if (polygonColor) {
          fill.setColor(polygonColor);
          vectorStyle.setFill(fill);
        }
        break;
      default:
        break;
    }
    return vectorStyle;
  }

  private getFeature(geoType: any, params: any): any {
    const feature = new ol.Feature();
    const geometry = params;
    if (geoType === "point") {
      const geom = new ol.geom.Point([geometry.x, geometry.y]);
      feature.setGeometry(geom);
    } else if (geoType === "polyline") {
      const geom = new ol.geom.MultiLineString(geometry.paths);
      feature.setGeometry(geom);
    } else if (geoType === "polygon") {
      const geom = new ol.geom.Polygon(geometry.rings);
      feature.setGeometry(geom);
    } else {
      console.error("请检查输入的symbol或defaultSymbol是否正确!");
      return false;
    }
    return feature;
  }

  private changeFeatureStyle(feature: any) {
    const selectStyle: any = {};
    if (!OverlayPGIS.hlFeatures) {
      return;
    }

    if (this.preSelected[0] && this.preSelected[1]) {
      this.preSelected[0].setStyle(this.preSelected[1]);
    }

    const style = feature.getStyle();
    const icon = style.getImage();
    const image = icon.getImage();
    this.preSelected = [feature, style];
    if (!selectStyle[image.src]) {
      const canvas = document.createElement("canvas");
      const context: any = canvas.getContext("2d");
      canvas.width = image.width;
      canvas.height = image.height;
      context.drawImage(image, 0, 0, image.width, image.height);
      const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
      const data = imageData.data;
      for (let i = 0, ii = data.length; i < ii; i = i + (i % 4 == 2 ? 2 : 1)) {
        data[i] = 255 - data[i];
      }
      context.putImageData(imageData, 0, 0);
      selectStyle[image.src] = createStyle(undefined, canvas);
    }

    feature.setStyle(selectStyle[image.src]);

    function createStyle(src: any, img: any) {
      return new ol.style.Style({
        image: new ol.style.Icon({
          // anchor: [0.5, 0.96],
          crossOrigin: "anonymous",
          src: src,
          img: img,
          imgSize: img ? [img.width, img.height] : undefined
        })
      });
    }
  }

  private addHighlightFrame(feature: any) {
    const center = feature.getGeometry().getCoordinates();
    const centerPixel = this.view.getPixelFromCoordinate(center);
    const style = feature.getStyle();
    const icon = style.getImage();
    const imageSize = icon.getSize();
    const anchor = icon.getAnchor();

    const leftTopPixel = [
      centerPixel[0] - (1 / 2) * imageSize[0],
      centerPixel[1] - (1 / 2) * imageSize[1]
    ];
    const leftTop = this.view.getCoordinateFromPixel(leftTopPixel);
    const rightTopPixel = [
      centerPixel[0] + (1 / 2) * imageSize[0],
      centerPixel[1] - (1 / 2) * imageSize[1]
    ];
    const rightTop = this.view.getCoordinateFromPixel(rightTopPixel);
    const leftBottomPixel = [
      centerPixel[0] - (1 / 2) * imageSize[0],
      centerPixel[1] + (1 / 2) * imageSize[1]
    ];
    const leftBottom = this.view.getCoordinateFromPixel(leftBottomPixel);
    const rightBottomPixel = [
      centerPixel[0] + (1 / 2) * imageSize[0],
      centerPixel[1] + (1 / 2) * imageSize[1]
    ];
    const rightBottom = this.view.getCoordinateFromPixel(rightBottomPixel);

    const lineGeometry = [leftTop, rightTop, rightBottom, leftBottom, leftTop];
    const lineStroke = new ol.style.Stroke({
      color: "rgb(0,253,253)",
      width: 3
    });
    const lineStyle = new ol.style.Style({
      stroke: lineStroke
    });
    const hlFeature = new ol.Feature();
    const geom = new ol.geom.LineString(lineGeometry);
    hlFeature.setGeometry(geom);
    hlFeature.setStyle(lineStyle);
    const featureType = "hlFeatures";
    this.getOverlayLayer(featureType).then((layer: any) => {
      layer.getSource().clear();
      layer.getSource().addFeature(hlFeature);
    });
  }

  private getGeoType(type: any) {
    let lowerCase = type.toLowerCase();
    let drawType = lowerCase;
    switch (lowerCase) {
      case "point":
        drawType = "Point";
        break;
      case "polyline":
        drawType = "MultiLineString";
        break;
      case "polygon":
        drawType = "Polygon";
        break;
      case "rectangle":
        drawType = "Circle";
        break;
      case "circle":
        drawType = "Circle";
        break;
      default:
        break;
    }

    return drawType;
  }


  private _formatSymbolType(type: any): any {
    let res = type;
    switch (type) {
      case "line":
      case "simple-line":
        res = "polyline";
        break;
      case "point-2d":
        res = "point";
      case "fill":
      case "simple-fill":
        res = "polygon";
        break;
      default:
        break;
    }
    return res;
  }

}

